<template lang="pug">
v-list-item(
  color="secondary"
  :input-value="selected && (selected.id === item.id)"
  :read-only="onlyView"
  @click="$emit('select', item)"
)
  v-list-item-icon
    tooltip-wrap(
      :text="!isValid ? 'Не все обязательные поля заполнены' : ''"
    )
      v-badge(
        dot
        overlap
        :color="!isValid ? 'error' : 'success'"
      )
        v-icon mdi-account-outline
  v-list-item-content
    v-list-item-title {{ getFullName(item) }}
  v-list-item-avatar(v-if="!onlyView")
    tooltip-wrap(text="Исключить")
      v-btn(
        fab
        text
        :loading="loading"
        @click.stop.prevent="$emit('remove', item)"
      ): v-icon(color="secondary") mdi-minus-circle

</template>
<script>
export default {
  props: {
    item: { type: Object, required: true },
    selected: { type: Object, default: null },
    isValid: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    onlyView: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  methods: {
    getFullName(item) {
      if (item.full_name) return item.full_name;
      return `${item.last_name} ${item.first_name} ${item.middle_name}`;
    },
  },
};
</script>
